import { Button, CircularProgress, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  useGetAssessmentQuery,
  useGetSubmissionQuery,
} from "../../../redux/Assessment/assessmentApis";
import { CandidateDetails } from "../../../redux/Hire/jobRequestApi";

type Props = {
  candidate?: CandidateDetails;
  jobId?: string;
};

enum AssessmentViews {
  form = "form",
  info = "info",
  feedback = "feedback",
  feedbackView = "feedbackView",
  loading = "loading",
}

const Assessment = ({ candidate, jobId }: Props) => {
  const navigate = useNavigate();
  const { data: submissionData, isLoading: isLoadingSubmission } =
    useGetSubmissionQuery({
      candidateId: candidate?.id.toString() || "",
      jobId: jobId || "",
      stage: candidate?.stage || "",
    });
  const { data: assessmentData, isLoading: isLoadingAssessment } =
    useGetAssessmentQuery({
      candidateId: candidate?.id.toString() || "",
      jobId: jobId || "",
      stage: candidate?.stage || "",
    });

  let view: AssessmentViews = AssessmentViews.form;

  if (assessmentData?.successful) view = AssessmentViews.info;

  if (submissionData?.successful && submissionData.data.submissionAt)
    view = AssessmentViews.feedback;

  if (submissionData?.successful && submissionData.data.feedBackText)
    view = AssessmentViews.feedbackView;

  if (isLoadingAssessment || isLoadingSubmission)
    view = AssessmentViews.loading;

  return (
    <Grid container gap={2} alignItems="center">
      {view === AssessmentViews.loading && <CircularProgress size={20} />}
      {view === AssessmentViews.info && (
        <Typography fontSize={"14px"} color={"#0F1829"}>
          Assessment guidelines sent to the candidate.
        </Typography>
      )}
      {view === AssessmentViews.feedback && (
        <>
          <Typography fontSize={"14px"} color={"#0F1829"}>
            Candidate has submitted the assessment.{" "}
          </Typography>
          <Button
            variant="outlined"
            onClick={() => {
              navigate(
                `/candidates/${candidate?.id}?jobId=${jobId}&stage=${candidate?.stage}`,
              );
            }}
          >
            View Submission
          </Button>
        </>
      )}
      {view === AssessmentViews.feedbackView && (
        <Button
          variant="outlined"
          onClick={() => {
            navigate(
              `/candidates/${candidate?.id}?jobId=${jobId}&stage=${candidate?.stage}`,
            );
          }}
        >
          View Feedback
        </Button>
      )}
      {view === AssessmentViews.form && (
        <Button
          variant="outlined"
          onClick={() => {
            navigate(
              `/candidates/${candidate?.id}?jobId=${jobId}&stage=${candidate?.stage}`,
            );
          }}
        >
          Send Assessment to candidate
        </Button>
      )}
    </Grid>
  );
};

export default Assessment;
